import config from '@app/config'
import type { AnalyticsUser } from '@app/types/analytics'

import ga from '@app/utils/ga'
import { omit } from '@app/utils/omit'
import ym from '@app/utils/ym'

import type { Amplitude } from './Amplitude'

if (IS_BROWSER && typeof config.gaTrackingCode === 'string') {
  ga.init(config.gaTrackingCode)
}

/** Not an event: every provider keeps its own identity, and a session change has to reach them all. */
export function analyticsIdentify(amplitude: Amplitude, user: AnalyticsUser | null) {
  currentUser = user
  amplitude.identify(user)
  if (user) {
    ym('setUserID', user.yandex_metrika_user_id)
    ym('userParams', omit(getUserData(), 'user_id'))
  } else {
    ym('setUserID', '')
    ym('userParams', {})
  }
  ga('set', 'userId', user?.id || null)
}

/** The dimensions Metrika and GTM are given beside an event. The other providers never took them. */
export const getUserData = () => {
  let data: any = {}
  if (currentUser) {
    data = {
      ...data,
      user_id: 'token' in currentUser ? currentUser.token : currentUser.id,
      city_id: currentUser && 'region_id' in currentUser ? currentUser.region_id : null,
      account_type: currentUser.account_type,
    }
    if (currentUser.account_type !== 'visitor') {
      data = {
        ...data,
        completed_requests_count: currentUser.completed_requests_count,
        confirmed_requests_count: currentUser.confirmed_requests_count,
      }
    }

    if (currentUser.account_type === 'parent') {
      data = {
        ...data,
        subscriptions_count: currentUser.subscriptions_count,
        payments_count: currentUser.payments_count,
        hidden_search: currentUser.hidden_search,
      }
    }
  }

  return data
}

let currentUser: AnalyticsUser | null = null
